import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  menu__list: {
    '& li': {
      display: 'flex',
      alignItems: 'center',
      borderBottom: '1px solid #DDD',
      paddingBottom: '10px',
      '&:last-child':{
        borderBottom: 'none',
        paddingBottom: '0'
      }
    },
  },

  menu__link: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: 'black',
    cursor: 'pointer',
  },

  menu__link_active: {
    fontWeight: 600,
    color: theme.palette.primary.main,
  },

  menu__desktopList: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridGap: '31px',
	'@media (max-width: 1110px)': {
      gridGap: '15px',
    },
  },

  menuIco: {
    marginRight: '11px',
  },
  menu__mobileMenu: {
    boxShadow: '0px 2px 1px 1px rgb(205 205 205 / 50%)',
    position: 'absolute',
    top: '-199px',
    left: 0,
    width: '100%',
    background: 'white',
    transition: '400ms',
    opacity: 0,
    display: 'grid',
    gridGap: '5px',
    [theme.breakpoints.down('lg')]: {
      padding: '20px',
    },
  },
  menu__mobileMenu_active: {
    top: '80px',
    opacity: 1,
    '& > a':{
      paddingBottom: '10px',
      '&:last-child':{
        paddingBottom: '0'
      }
    }
  },

  hr: {
    width: '100%',
    border: '0.5px solid #DAEFFB',
    background: '#DAEFFB',
  },

  iconWrap:{
    display: 'flex',
    gap: '16px',
    zIndex: 99
  },

  iconBtn:{
    padding: '0 !important'
  },

  activeIcon: {
    '& path':{
      fill: '#fff'
    },
    '& rect':{
      fill: '#79C5F1'
    }
  }
}));
